import { Accordion, ContentTemplate, SectionHeader } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CandidateProfileResponseObject } from 'web-library/models/AccountManagementConfiguration';
import CandidatePersonalParticulars from '../../../../pages/userAccountManagement/CreateEditViewCandidateAccountDetails/CandidatePersonalParticulars';
import CandidateNextOfKinDetails from '../../../../pages/userAccountManagement/CreateEditViewCandidateAccountDetails/CandidateNextOfKinDetails';
import CandidateContactInformation from '../../../../pages/userAccountManagement/CreateEditViewCandidateAccountDetails/CandidateContactInformation';

export interface CandidateDetailsProps {
  candidateProfileDetails: CandidateProfileResponseObject;
}

const CandidateDetails = ({ candidateProfileDetails }: CandidateDetailsProps) => {
  const { t } = useTranslation();

  return (
    <ContentTemplate type="full">
      <SectionHeader title={t('admin->>UserAccountManagement.AccountDetails')} />
      <Accordion defaultExpanded header={t('admin->>UserAccountManagement.PersonalParticulars')}>
        {candidateProfileDetails && (
          <CandidatePersonalParticulars
            candidateProfileDetails={candidateProfileDetails}
            isEditState={false}
            isTaskDetails
          />
        )}
      </Accordion>

      <Accordion defaultExpanded header={t('admin->>UserAccountManagement.ContactInformation')}>
        {candidateProfileDetails && (
          <CandidateContactInformation
            candidateProfileDetails={candidateProfileDetails}
            isEditState={false}
          />
        )}
      </Accordion>
      <Accordion defaultExpanded header={t('admin->>UserAccountManagement.NextOfKinDetails')}>
        {candidateProfileDetails && (
          <CandidateNextOfKinDetails
            candidateProfileDetails={candidateProfileDetails}
            isEditState={false}
          />
        )}
      </Accordion>
    </ContentTemplate>
  );
};

export default CandidateDetails;
